import { render } from "./chatDetail.vue?vue&type=template&id=afb619d0&scoped=true"
import script from "./chatDetail.vue?vue&type=script&lang=js"
export * from "./chatDetail.vue?vue&type=script&lang=js"

import "./chatDetail.vue?vue&type=style&index=0&id=afb619d0&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb619d0"]])

export default __exports__